import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { canLoad } from './auth/role-auth.guard';
import { LoginComponent } from './login/login.component';

import { RegisterBoardComponent } from './board/register-board.component';
import { RouterConstants } from './_models/router-constants';
import { Backend } from './_models/backend';
import Role = Backend.Role;

const boardRoles: Role[] = ['ROLE_BOARD'];
const adminRoles: Role[] = ['ROLE_ADMIN'];
const schoolAdminRoles: Role[] = ['ROLE_SCHOOLADMIN'];
const teacherRoles: Role[] = ['ROLE_TEACHER', 'ROLE_MENTOR']; // TODO SA

const routes: Routes = [
  // board
  {
    path: RouterConstants.BOARD_REGISTER,
    component: RegisterBoardComponent
  },
  {
    path: RouterConstants.BOARD,
    loadChildren: () => import('./board/board.module').then(m => m.BoardModule),
    canMatch: [canLoad],
    data: {roles: boardRoles}
  },
  // admin
  {
    path: RouterConstants.ADMIN,
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canMatch: [canLoad],
    data: {roles: adminRoles}
  },
  // schooladmin
  {
    path: RouterConstants.SCHOOL_ADMIN,
    loadChildren: () => import('./schooladmin/schooladmin.module').then(m => m.SchoolAdminModule),
    canMatch: [canLoad],
    data: {roles: schoolAdminRoles}
  },
  // teacher
  {
    path: RouterConstants.TEACHER,
    loadChildren: () => import('./teacher/teacher.module').then(m => m.TeacherModule),
    canMatch: [canLoad],
    data: {roles: teacherRoles}
  },
  {path: RouterConstants.LOGIN, component: LoginComponent},
  {path: '', redirectTo: RouterConstants.TEACHER, pathMatch: 'full'},
  {path: '**', redirectTo: RouterConstants.TEACHER}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
